import { useState, useRef } from 'react';
import { fetch } from '../../../utils/api-wrapper';

export function usePlaidLinkToken(language) {
  const [linkToken, setLinkToken] = useState(null);
  const [publicTokenHandled, setPublicTokenHandled] = useState(false);
  const mountedRef = useRef(true);

  const generateLinkToken = () => {
    fetch(
      '/plaid/generate_link_token',
      'GET',
      { lang: language },
      (response) => {
        if (!mountedRef.current) return;
        setLinkToken(response.data.link_token);
      },
      (error) => {
        console.error('Error fetching link token:', error);
      }
    );
    return () => {
      mountedRef.current = false;
    };
  };

  const handlePublicToken = (public_token, metadata) => {
    fetch(
      '/plaid/register_user_for_plaid',
      'POST',
      { public_token, metadata },
      (response) => {
        setPublicTokenHandled(true);
      },
      (error) => {
        console.error('Error handling public token:', error);
      }
    );
  };

  return {
    linkToken,
    publicTokenHandled,
    setPublicTokenHandled,
    generateLinkToken,
    handlePublicToken,
  };
}
